import React, { Component } from 'react'
import Dropdown from '../Dropdown/Dropdown';
import Input from '../Input';
import '../../assets/styles/components/instrument/place-order-option.scss'
import { connect } from 'react-redux';
import { formatFunctions, utilsFunction } from '../../helpers/functions';
import { dataType } from '@/constants/data-type';
import { INDEX_KEY } from '@/constants/keys.code';
import { ORDER_TYPE, STOP_TYPE_TYPE } from '@/constants/app';
import classnames from 'classnames';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { openPrePostDialog } from '@/actions/app/dialog.action'
import descriptionIcon from '@/assets/images/icons/icon_description.png';

const DESELECT_OPTION = '--';

class PlaceOrderOption extends Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.state = {
      orderType: props.orderType ? props.orderType : props.orderTypes.length > 0 ? props.orderTypes[0].value : '',
      priceMinusStep: {
        'tableCode': '01',
        'fromPrice': 0.001,
        'toPrice': 0.25,
        'spread': 0.001
      },
      pricePlusStep: {
        'tableCode': '01',
        'fromPrice': 0.001,
        'toPrice': 0.25,
        'spread': 0.001
      },
      stopPriceMinusStep: {
        'tableCode': '01',
        'fromPrice': 0.001,
        'toPrice': 0.25,
        'spread': 0.001
      },
      stopPricePlusStep: {
        'tableCode': '01',
        'fromPrice': 0.001,
        'toPrice': 0.25,
        'spread': 0.001
      },
      newGoodTillDates: [{ value: DESELECT_OPTION, label: DESELECT_OPTION }, ...props.goodTillDates],
      grossAmount: 0,
    }
  }

  render() {
    const { language, tradeInformation, lotSize, orderTypes, isModifyOrder, showGrossAmount, showGrossAmountBorder} = this.props;
    const {
      priceMinusStep,
      pricePlusStep,
      newGoodTillDates,
      orderType,
      stopPriceMinusStep,
      stopPricePlusStep,
      grossAmount,
    } = this.state;
    const usePrePost = iTradeEnv?.pages?.trade?.usePrePost
    return (
      <div className="place-order-option-container">
        {!isModifyOrder && <div className="option-item">
          <label>{language.common_order_type}</label>
          <div className="input">
            <Dropdown
              textCenter
              style={{ height: '30px', width: '100%', textAlign: 'left' }}
              selectedOptions={[this.hasOption(orderTypes, orderType, orderTypes[0])]}
              options={orderTypes}
              innerRef={e => this.orderTypeRef = e}
              onChange={this.handleChangeOrderType}
            />
          </div>
        </div>}
        {!isModifyOrder && orderType === ORDER_TYPE.TRIGGER_ORDER.value &&
          <div className="option-item">
            <label>{language.common_stop_price}</label>
            <div className="input stop-price-input">
              <Dropdown
                textCenter
                style={{ height: '30px' }}
                selectedOptions={[STOP_TYPE_TYPE[0]]}
                options={STOP_TYPE_TYPE}
                innerRef={e => this.stopTypeDirectionRef = e}
              />
              <Input style={{ height: '30px', flexGrow: '1' }}
                innerRef={e => this.stopPriceRef = e}
                priceMode={true}
                minusStep={stopPriceMinusStep.spread}
                plusStep={stopPricePlusStep.spread}
                onChange={(price) => this.handleChangePrice(price, true)}
                // prevKey={INDEX_KEY.PRICE}
                currentKey={INDEX_KEY.STOP_PRICE}
                // nextKey={INDEX_KEY.GTD}
                onKeyPress={this.keySequence}
              />
            </div>
          </div>}
        {utilsFunction.isOrderNeedEnterPrice(orderType) && <div className="option-item">
          {isModifyOrder
            ? <label>{language.order_new_properties.format(language.common_price)}</label>
            : <label>{language.common_price}</label>
          }
          <div className="input">
            <Input style={{ width: '100%', height: '30px' }}
              innerRef={e => this.priceRef = e}
              priceMode={true}
              minusStep={priceMinusStep.spread}
              plusStep={pricePlusStep.spread}
              onChange={this.handleChangePrice}
              prevKey={INDEX_KEY.ORDER_TYPE}
              currentKey={INDEX_KEY.PRICE}
              nextKey={INDEX_KEY.QTY}
              onKeyPress={this.keySequence} />
          </div>
        </div>}
        <div className="option-item">
          {isModifyOrder
            ? <label>{language.order_new_properties.format(language.common_quantity)}</label>
            : <label>{language.common_quantity}</label>
          }
          <div className="input">
            <Input style={{ width: '100%', height: '30px' }}
              innerRef={e => this.quantityRef = e}
              step={lotSize}
              onChange={this.handleChangeQuantity}
              prevKey={INDEX_KEY.PRICE}
              currentKey={INDEX_KEY.QTY}
              nextKey={INDEX_KEY.GTD}
              onKeyPress={this.keySequence}
              dataType={dataType.NUMBER} />
          </div>
        </div>
        {!isModifyOrder && <div className="option-item">
          <label>{language.common_good_till_date}</label>
          <div className="input">
            <Dropdown
              textCenter
              style={{ height: '30px', width: '100%', textAlign: 'left' }}
              selectedOptions={[newGoodTillDates[0]]}
              options={newGoodTillDates}
              innerRef={e => this.goodTillDateRef = e}
            />
          </div>
        </div>}
        {usePrePost && <div className="option-item" style={{height:'30px'}}>
          <label onClick={() => {usePrePost && openPrePostDialog()}} className="description_label">
            {language.common_order_statement}
            <img src={descriptionIcon}/>
          </label>
        </div>}
        {showGrossAmount && <div className={classnames("gross-amount", showGrossAmountBorder ? "border-top" : "")}>
          <label>{language.common_gross_amount}</label>
          <span>{grossAmount}</span>
        </div>}
        {tradeInformation && <div className="asset-index">
          <div className="asset-item">
            <label>{language.place_order_dialog_buy_cash}</label>
            <span className="value">
              {utilsFunction.currencyFormatter('23000')}
            </span>
          </div>
          <div className="asset-item">
            <label>{language.common_buying_power}</label>
            <span className="value">
              {utilsFunction.currencyFormatter('23000')}
            </span>
          </div>
          <div className="asset-item">
            <label>{language.place_order_dialog_sell_cash}</label>
            <span className="value">
              {utilsFunction.currencyFormatter('1000')}
            </span>
          </div>
          <div className="asset-item">
            <label>{language.place_order_dialog_gross_amount}</label>
            <span className="value">
              {utilsFunction.currencyFormatter('100810')}
            </span>
          </div>
        </div>}
      </div>
    )
  }

  hasOption = (options, value, defaultOption) => {
    const hasItem = options.find(v => v.value === value)
    if (hasItem) return hasItem
    return defaultOption
  }

  computeGrossAmount = (price, quantity) => {
    const { currencyID } = this.props;
    const grossAmount = formatFunctions.dataFormat(price * quantity, dataType.CASH);
    // const grossAmountText = `${grossAmount > 0 ? currencyID : ''} ${grossAmount}`
    const grossAmountText = `${grossAmount} ${currencyID }`
    this.setState({ grossAmount: grossAmountText })
  }

  handleChangeOrderType = (orderType) => {
    if (orderType.length > 0) {
      const atAuctionBuy = iTradeEnv?.pages?.trade?.atAuctionBuy ?? false;
      this.setState({
        orderType: orderType[0].value 
      })
      if(orderType[0].value === ORDER_TYPE.AT_AUCTION.value && !atAuctionBuy){
        this.setState({
          grossAmount:'-'
        })
      }
      this.props.handleAllowBuy(orderType);
    }
  }

  handleChangeQuantity = (quantity) => {
    let changeData;
    if(utilsFunction.isOrderNeedEnterPrice(this.state.orderType)){
      changeData = {
        price: this.priceRef.getValue(),
        quantity,
      }
    }else{
      changeData = {
        price: '',
        quantity,
      }
    }
    if (this.state.orderType === ORDER_TYPE.TRIGGER_ORDER) {
      changeData.stopPrice = this.stopPriceRef.getValue()
    }
    this.props.onChange(changeData);
    if(utilsFunction.isOrderNeedEnterPrice(this.state.orderType)){
      this.computeGrossAmount(changeData.price, changeData.quantity);
    }
  }

  handleChangePrice = (price, isStopPrice = false) => {
    const priceNumber = parseFloat(price);
    if (!isNaN(priceNumber)) {
      const { priceMinusStep, pricePlusStep, stopPriceMinusStep, stopPricePlusStep } = this.state;
      const minusStep = isStopPrice ? stopPriceMinusStep : priceMinusStep;
      const plusStep = isStopPrice ? stopPricePlusStep : pricePlusStep;
      if (minusStep.fromPrice === plusStep.fromPrice) {
        if (priceNumber <= minusStep.fromPrice || priceNumber >= minusStep.toPrice) {
          this.determinePriceStep(priceNumber, isStopPrice);
        }
      } else {
        this.determinePriceStep(priceNumber, isStopPrice);
      }
      const changeData = {
        price: isStopPrice ? this.priceRef.getValue() : priceNumber,
        quantity: this.quantityRef.getValue(),
      }
      if (this.state.orderType === ORDER_TYPE.TRIGGER_ORDER) {
        changeData.stopPrice = isStopPrice ? priceNumber : this.stopPriceRef.getValue()
      }
      this.props.onChange(changeData);
      this.computeGrossAmount(changeData.price, changeData.quantity);
    }
  }

  determinePriceStep(price, isStopPrice = false) {
    const { spreadTable } = this.props;
    if (price) {
      for (let i = 0; i < spreadTable.length; i++) {
        const tmp = spreadTable[i];
        if (price < tmp.fromPrice || (price > tmp.fromPrice && price < tmp.toPrice)) {
          isStopPrice
            ? this.setState({ stopPriceMinusStep: tmp, stopPricePlusStep: tmp })
            : this.setState({ priceMinusStep: tmp, pricePlusStep: tmp })
          break;
        } else if (price == tmp.fromPrice) {
          const minusStep = i === 0 ? tmp : spreadTable[i - 1];
          isStopPrice
            ? this.setState({ stopPriceMinusStep: minusStep, stopPricePlusStep: tmp })
            : this.setState({ priceMinusStep: minusStep, pricePlusStep: tmp })
          break;
        } else if (price == tmp.toPrice && i < spreadTable.length - 1) {
          isStopPrice
            ? this.setState({ stopPriceMinusStep: tmp, stopPricePlusStep: spreadTable[i + 1] })
            : this.setState({ priceMinusStep: tmp, pricePlusStep: spreadTable[i + 1] })
          break;
        }
        if (i === spreadTable.length - 1) {
          isStopPrice
            ? this.setState({ stopPriceMinusStep: tmp, stopPricePlusStep: tmp })
            : this.setState({ priceMinusStep: tmp, pricePlusStep: tmp })
          break;
        }
      }
    } else {
      const tmp = spreadTable[0] || this.state.priceMinusStep;
      
      isStopPrice
        ? this.setState({ stopPriceMinusStep: tmp, stopPricePlusStep: tmp })
        : this.setState({ priceMinusStep: tmp, pricePlusStep: tmp })
    }
  }

  focusPrice = () => {
    this.priceRef.focusInput();
  }

  setQuantity = (qty) => {
    this.quantityRef.setValue(qty);
    if(utilsFunction.isOrderNeedEnterPrice(this.state.orderType)){
      const price = this.priceRef.getValue();
      this.computeGrossAmount(price, qty);
    }
  }

  setPrice = (price) => {
    if(utilsFunction.isOrderNeedEnterPrice(this.state.orderType)){
      this.priceRef.setValue(price);
      const quantity = this.quantityRef.getValue();
      this.computeGrossAmount(price, quantity);
    }
  }

  setGoodTillDate = (date) => {
    if (date) {
      this.goodTillDateRef.setValue([date]);
    }
  }

  setOrderType = (type, orderData) => {
    if (type) {
      this.orderTypeRef.setValue([type]);
      this.setState({ orderType: type.value }, () => {
        if (type.value === ORDER_TYPE.TRIGGER_ORDER.value) {
          this.stopTypeDirectionRef.setValue([orderData.stopType]);
          this.stopPriceRef.setValue(orderData.stopPrice);
        }
      })
    }
  }

  reset = () => {
    this.setOrderType(this.props.orderTypes[0])
    this.setPrice(formatFunctions.dataFormat(0, dataType.CURRENCY));
    this.setQuantity(formatFunctions.dataFormat(0, dataType.NUMBER));
    this.setGoodTillDate(this.state.newGoodTillDates[0]);
  }

  validateInput = () => {
    this.priceRef.formatNumber(this.priceRef.getValue());
    this.quantityRef.formatNumber(this.quantityRef.getValue());
    if (this.state.orderType === ORDER_TYPE.TRIGGER_ORDER.value) {
      this.stopPriceRef.formatNumber(this.stopPriceRef.getValue())
    }
  }

  getOptions = () => {
    let orderType = JSON.parse(JSON.stringify(this.state.orderType));
    let goodTillDate = '';
    if (!this.props.isModifyOrder) {
      orderType = this.orderTypeRef.getValue()[0];
      const goodTillDateArray = this.goodTillDateRef.getValue();
      if (goodTillDateArray.length > 0) {
        goodTillDate = goodTillDateArray[0]
        if (goodTillDate.value === DESELECT_OPTION) {
          goodTillDate = '';
        }
      }
    }
    const quantity = this.quantityRef.getValue();
    let stopType = null;
    let stopPrice = null;
    if (!this.props.isModifyOrder && this.state.orderType === ORDER_TYPE.TRIGGER_ORDER.value) {
      stopType = this.stopTypeDirectionRef.getValue()[0];
      stopPrice = this.stopPriceRef.getValue();
    }
    if(utilsFunction.isOrderNeedEnterPrice(orderType)){
      const price = this.priceRef.getValue();
      return {
        orderType,
        price,
        quantity,
        goodTillDate,
        stopType,
        stopPrice,
      }
    }
    return {
      orderType,
      quantity,
      goodTillDate,
      stopType,
      stopPrice,
    }
  }

  keySequence = (data) => {
    switch (data.currentKey) {
      case INDEX_KEY.PRICE:
        if (this.priceRef.getValue() === '0' || this.priceRef.getValue() === "") {
          return;
        }
        this.quantityRef.inputRef.focus();
        break;
      case INDEX_KEY.QTY:
        if (this.quantityRef.getValue() === '0' || this.quantityRef.getValue() === "") {
          return;
        }
        this.quantityRef.inputRef.blur();
        this.goodTillDateRef.toggleMenuOption();
        break;
      case INDEX_KEY.STOP_PRICE:
        if (this.stopPriceRef.getValue() === '0' || this.stopPriceRef.getValue() === "") {
          return;
        }
        this.priceRef.inputRef.focus();
        break;
      default:
        break;
    }
  }

  updatePriceStepInit = () => {
    const { spreadTable } = this.props;
    if (spreadTable && spreadTable.length > 0) {
      this.setState({
        priceMinusStep: spreadTable[0],
        pricePlusStep: spreadTable[0],
        stopPriceMinusStep: spreadTable[0],
        stopPricePlusStep: spreadTable[0]
      })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.spreadTable !== this.props.spreadTable) {
      this.updatePriceStepInit();
    }
    if (prevProps.goodTillDates !== this.props.goodTillDates) {
      this.setState({
        newGoodTillDates: [{ value: DESELECT_OPTION, label: DESELECT_OPTION }, ...this.props.goodTillDates]
      })
    }
    if(prevProps.orderTypes !== this.props.orderTypes){
      // setTimeout(() => {
      //   this.setState({
      //     orderType:this.props.orderTypes[0]
      //   })
      // }, 200)
    }
  }

  componentDidMount() {
    this.updatePriceStepInit();
  }
}

PlaceOrderOption.defaultProps = {
  innerRef: () => {
  },
  tradeInformation: null,
  spreadTable: [],
  lotSize: 1,
  isModifyOrder: false,
  onChange: () => {
  },
  openGTDByTab: null,
  showGrossAmount: null,
  showGrossAmountBorder: false,
  currencyID: 'HKD'
}

export default connect(
  state => ({
    language: state.app.language,
    goodTillDates: state.trade.goodTillDates,
    orderTypes: state.trade.orderTypes
  })
)(PlaceOrderOption)
